import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';

function toDateFnsFormat(momentFmt: string): string {
  return momentFmt
    .replace(/YYYY/g, 'yyyy')
    .replace(/YY/g, 'yy')
    .replace(/DD/g, 'dd')
    .replace(/\bD\b/g, 'd')
    .replace(/\bA\b/g, 'a');
}

@Pipe({ name: 'dateFormat' })
export class MomentPipe implements PipeTransform {
  transform(value: Date | string, dateFormat: string): any {
    if (!value) return 'Not Available';
    try {
      return format(new Date(value), toDateFnsFormat(dateFormat));
    } catch {
      return 'Not Available';
    }
  }
}
